import { theme } from '../../ThemeContext/ThemeObject';

export const styles = {
  scoutNavyIcon: {
    color: '#084D6D',
    fontSize: '20px'
  },
  externalViewHeaderItems: {
    flexDirection: 'row',
    columnGap: 1,
    alignItems: 'center',
    fontSize: '14px',
    color: '#333333'
  },
  sectionContainer: {
    padding: { xs: 2, sm: 3 },
    borderRadius: '6px',
    border: '1px solid #E3E3E3',
    rowGap: 2
  },
  summary: {
    fontFamily: 'Source Sans Pro',
    padding: { xs: '4px 8px 16px 4px', sm: '4px 20px 20px 8px' },
    '& p': {
      fontFamily: 'Source Sans Pro',
      fontSize: { xs: '14px', sm: '15px' },
      fontWeight: 'normal'
    },
    '& ul': {
      fontFamily: 'Source Sans Pro',
      fontWeight: 'bold',
      fontSize: { xs: '14px', sm: '15px' },
      listStyleType: 'unset',
      marginLeft: { xs: '12px', sm: '16px' },
      marginTop: '16px',
      marginBottom: '8px',
      '& li': {
        marginBottom: '6px'
      }
    }
  },
  tableWrapper: {
    tableLayout: 'auto !important',
    border: 'none',
    'td, th, tr, thead': {
      fontFamily: 'Source Sans Pro, sans-serif',
      border: 'none',
      backgroundColor: '#FFFFFF',
      textTransform: 'none',
      padding: { xs: '8px 4px', sm: '12px 0px' },
      cursor: 'inherit'
    },
    th: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      paddingBottom: { xs: '12px', sm: '16px' },
      fontSize: { xs: '13px', sm: '14px' },
      '& .Mui-active': {
        color: theme.palette.primary.main
      }
    }
  },
  fileIcon: {
    cursor: 'pointer',
    width: { xs: '40px', sm: '50px' },
    height: { xs: '40px', sm: '50px' },
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: { xs: '12px', sm: '20px' },
    backgroundColor: '#084D6D10',
    '& svg': {
      color: theme.palette.primary.main,
      margin: '0px 2px 2px 0px'
    }
  },
  fileName: {
    color: theme.palette.primary.main,
    fontSize: { xs: '13px', sm: '15px' },
    fontWeight: 'bold',
    cursor: 'pointer',
    wordBreak: 'break-word'
  },
  fileAttachedBy: {
    color: '#333333',
    fontSize: { xs: '13px', sm: '15px' },
    wordBreak: 'break-word'
  },
  preview: {
    color: '#666666',
    fontSize: 'medium',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  tableActionIcon: {
    '&:focus': {
      outline: 'none'
    }
  },
  downloadIcon: { fontSize: 16, color: theme.palette.common.grey },
  linkedInURLLink: {
    cursor: 'pointer',
    maxWidth: { xs: '150px', sm: '200px' },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#084D6D',
    fontFamily: 'Source Sans Pro',
    fontSize: { xs: '13px', sm: '14px' },
    '&:hover': { textDecoration: 'underline' }
  },
  formResponseAnswerView: {
    '& > div > div:first-of-type': {
      color: theme.palette.primary.dark,
      fontWeight: 'bold'
    },
    '& > div > div:not(:first-of-type)': {
      color: '#333333'
    },
    '& > div': {
      paddingLeft: 0
    }
  }
};
